import React__default from 'react';

var LobbyRoomWinner = function (_a) {
    var playerIdText = _a.playerIdText, betAmountText = _a.betAmountText, winAmountText = _a.winAmountText, imgSrc = _a.imgSrc;
    return (React__default.createElement("div", { className: 'pgc-lobby-room-winner' },
        imgSrc && React__default.createElement("img", { src: imgSrc, alt: '', className: 'pgc-lobby-room-winner-img' }),
        React__default.createElement("p", { className: 'pgc-winner-r-text' }, playerIdText),
        React__default.createElement("p", { className: 'pgc-winner-r-text' }, betAmountText),
        React__default.createElement("p", { className: 'pgc-winner-r-text win' }, winAmountText)));
};

export { LobbyRoomWinner };
